import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ReferencePhysicianDto } from 'src/app/core/classes/physician-order';
@Component({
    selector: 'app-multiple-physician-address-dialog',
    templateUrl: './multiple-physician-address-dialog.component.html',
    styleUrls: ['./multiple-physician-address-dialog.component.scss'],
    standalone: false
})
export class MultiplePhysicianAddressDialogComponent implements OnInit {
  options: ReferencePhysicianDto = new ReferencePhysicianDto();
  test: string;
  selectedOption: any;
  selectedOptionTemp: any;
  constructor(
    public dialogRef: MatDialogRef<MultiplePhysicianAddressDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.options = this.data as ReferencePhysicianDto;
    this.options.addressesDto.forEach(element => {
      element.checked = false;
    });
  }

  close() {
    this.dialogRef.close(this.selectedOption);
  }

  select() {
    this.selectedOption = this.selectedOptionTemp;
    this.close();
  }

  optionSelected(option: any) {
    this.selectedOptionTemp = option.addressLine1;
    this.options.addressesDto.forEach(x => {
      if (x.addressLine1 !== option.addressLine1) {
        x.checked = false;
      } else {
        x.checked = true;
      }
    });
  }

}

